module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p8.1c95142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p8.png
// module id = gyFx
// module chunks = 10